import type { AnyAction } from "redux";
import type { Epic } from "redux-observable";

import { hoursToMilliseconds } from "~/tools/date-time";
import { empty, filter, flatMap, map, timer } from "~/tools/rxjs";

import { expireCSRFCookieAndRedirectToLoginPage } from "../../../backend/LoginApi";
import { combineEpicsAndCatchErrors } from "../../../generic/redux/CombineEpicsAndCatchErrors";
import { typedStream } from "../../../generic/redux/TypedRedux";
import { CSRF_TOKEN_COOKIE } from "../../../generic/request";
import { type CheckSession, type SetUiConfig, checkSession } from "../config/ConfigActions";
import { CHECK_SESSION, SET_UI_CONFIG } from "../config/ConfigActionTypes";
import { selectIsAuthEnabled } from "../config/ConfigSelectors";
import type { RootState } from "../RootState";

const ONE_DAY = hoursToMilliseconds(24);

export const DailySessionCheckEpic: Epic<AnyAction, CheckSession, RootState> = (actions, states) =>
	actions.pipe(
		typedStream<SetUiConfig>(SET_UI_CONFIG),
		filter(() => selectIsAuthEnabled(states.value)),
		flatMap(() => timer(0, ONE_DAY).pipe(map(checkSession))),
	);

export const SessionCheckEpic: Epic<AnyAction, AnyAction, RootState> = (actions) =>
	actions.pipe(
		typedStream<CheckSession>(CHECK_SESSION),
		filter(() => document.cookie.indexOf(CSRF_TOKEN_COOKIE) === -1),
		map(expireCSRFCookieAndRedirectToLoginPage),
		flatMap(() => empty()),
	);

export const SessionEpic = combineEpicsAndCatchErrors(DailySessionCheckEpic, SessionCheckEpic);
